import { render, staticRenderFns } from "./TipsModal.vue?vue&type=template&id=4d38d550"
import script from "./TipsModal.vue?vue&type=script&lang=js"
export * from "./TipsModal.vue?vue&type=script&lang=js"
import style0 from "./TipsModal.vue?vue&type=style&index=0&id=4d38d550&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports